
import api from "../request";

function getTimetableList(reqData) {
  return api
    .post("timetable/list", { reqData })
    .then(({ data }) => {
      return data;
    });
}

function addTimetable(formData) {
  return api
    .post("timetable/add", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(({ data }) => {
      return data;
    });
}

function editTimetable(reqData) {
  return api
    .post("timetable/edit", { reqData })
    .then(({ data }) => {
      return data;
    });
}


function deleteTimetable(reqData) {
  return api
    .post("timetable/delete", { reqData })
    .then(({ data }) => {
      return data;
    });
}

export default {
  getTimetableList,
  addTimetable,
  editTimetable,
  deleteTimetable,
};
